import { render, staticRenderFns } from "./summary-table.vue?vue&type=template&id=56af67a8&scoped=true"
import script from "./summary-table.vue?vue&type=script&lang=ts"
export * from "./summary-table.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56af67a8",
  null
  
)

export default component.exports